<template>
  <div class="system-params-container">
    <div class="side-bar">
      <div class="menu-title">
        系统参数列表
      </div>
      <ul class="side-menu">
        <li
          v-for="(item, index) in paramsGroup"
          :class="currentGroup === item ? 'current-group': ''"
          :key="index"
          @click="getParamsList(item)"
        >
          {{ item }}
        </li>
      </ul>
    </div>
    <div class="list-content">
      <div class="row-operation">
        <operationBtn
          :select-length="selectLength"
          @clickBtn="handleOperation"
        />
      </div>
      <div class="list">
        <commonTable
          ref="paramsTable"
          :thead="thead"
          empty="当前分组没有数据哦~"
          :tpropty="tpropty"
          :table-data="paramsList"
          :is-show-section="true"
          @handleSelectionChange="handleSelectionChange"
        />
      </div>
      <!-- <el-pagination
        background
        layout="slot,prev, pager, next"
        :total="total"
        :page-size="pagesize"
        :current-page="page"
        @current-change="getParamsList"
        v-show="paramsList.length !== 0"
      >
        <span class="total">
          共
          <em>{{ total }}</em>条信息
        </span>
      </el-pagination> -->
    </div>
    <addGroupDialog
      ref="addGroupDialog"
      @dialogSure="sureGroup"
    />
    <deleteDialog
      ref="deleteDialog"
      @deleteData="deleteData"
      :delete-tips="deleteTips"
    />
    <tipsDialog
      ref="tipsDialog"
      :tips-info="tipsInfo"
    />
  </div>
</template>
<script>
import APIS from '@apis/settings.js'
import commonTable from './components/list.vue'
import addGroupDialog from './components/addGroupDialog.vue'
import deleteDialog from '../category/components/deleteDialog'
import tipsDialog from '../category/components/tipsDialog.vue'
import operationBtn from '@components/common/operationBtns'
export default {
  components: {
    commonTable,
    addGroupDialog,
    deleteDialog,
    tipsDialog,
    operationBtn },
  data() {
    return {
      // side menu
      paramsGroup: [],
      currentGroup: '',
      // table
      thead: [{ label: '序号', width: 70 }, { label: '参数名称', align: 'left' }, { label: '参数值', align: 'left' }, { label: '附加值', align: 'left' }, { label: '参数说明', align: 'left' }],
      tpropty: [
        'index',
        'name',
        'value',
        'data',
        'desc'],
      paramsList: [],
      currentParams: {},
      selectedData: [],
      selectLength: 0,
      delIds: [],
      total: 0,
      pagesize: 10,
      page: 1,
      // tips dialog
      tipsInfo: '',
      // deleteDialog
      deleteTips: ''
    }
  },
  created() {
    this.getParamsGroup()
  },
  methods: {
    async getParamsGroup(currentGroup = '') {
      let { status, data } = await APIS.getParamsGroup()
      if (status === 0) {
        this.paramsGroup = data
        if (currentGroup) {
          let hasCurrentGroup = false
          this.paramsGroup.forEach(item => {
            if (item === currentGroup) {
              hasCurrentGroup = true
            }
          })
          this.currentGroup = hasCurrentGroup ? currentGroup : this.paramsGroup[0]
        } else {
          this.currentGroup = this.paramsGroup[0]
        }
        this.getParamsList(this.currentGroup)
        // this.$nextTick(() => {
        //   // document.querySelector('.current-group').scrollIntoView()
        // })
      }
    },
    async getParamsList(name) {
      this.currentGroup = name
      let params = { group: name }
      let { status, data } = await APIS.getParamsList({ data: params })
      if (status === 0) {
        this.paramsList = data.map((item, index) => {
          return {
            index: this.pagesize * (this.page - 1) + index + 1,
            name: item.name,
            value: item.value,
            data: item.data,
            desc: item.desc,
            id: item.id,
            group: item.group,
            order: item.order
          }
        })
      }
    },
    async sureGroup(paramData) {
      let params = {
        id: paramData.id || 0,
        group: paramData.group,
        name: paramData.name,
        value: paramData.value,
        data: paramData.data,
        memo: paramData.desc,
        order: paramData.order
      }
      let { status, message } = await APIS.saveParams({ data: params })
      if (status === 0) {
        this.$refs.addGroupDialog.$refs.dialog.cyDialogCommon = false
        this.getParamsGroup(paramData.group)
      } else {
        this.$refs.tipsDialog.$refs.dialog.cyDialogCommon = true
        this.tipsInfo = message
      }
    },
    handleSelectionChange(ids) {
      this.selectLength = ids.length
      this.selectedData = ids
    },
    handleOperation(operation) {
      switch (operation) {
        case 'delete':
          this.deleteTitle = '删除系统参数'
          this.tipsDetail = ''
          if (this.selectedData.length === 1) {
            this.delIds = this.selectedData[0]
            this.paramsList.forEach(item => {
              if (item.id === this.selectedData[0]) {
                this.currentParams = item
              }
            })
            this.deleteTips = `您确定要删除吗？`
          } else {
            this.delIds = this.selectedData.join(',')
            this.deleteTips = `您确定要删除${this.selectedData.length}个参数吗？`
          }
          this.$refs.deleteDialog.$refs.dialog.cyDialogCommon = true
          break
        case 'add':
          this.$refs.addGroupDialog.dialogTitle = '新增系统参数'
          this.$refs.addGroupDialog.initParmas({ group: this.currentGroup })
          this.$refs.addGroupDialog.$refs.dialog.cyDialogCommon = true
          break
        case 'edit':
          this.$refs.addGroupDialog.dialogTitle = '修改系统参数'
          this.paramsList.forEach(item => {
            if (item.id === this.selectedData[0]) {
              this.currentParams = item
            }
          })
          this.$refs.addGroupDialog.initParmas(this.currentParams)
          this.$refs.addGroupDialog.$refs.dialog.cyDialogCommon = true
          break
      }
    },
    async deleteData() {
      let params = {
        ids: this.delIds
      }
      let { status, message } = await APIS.deleteParams({ data: params })
      if (status === 0) {
        this.$refs.deleteDialog.$refs.dialog.cyDialogCommon = false
        this.getParamsGroup(this.currentGroup)
      } else {
        this.$refs.tipsDialog.$refs.dialog.cyDialogCommon = true
        this.tipsInfo = message
      }
    }
  }
}
</script>
<style lang="scss" scope>
.system-params-container {
  display: flex;
  justify-content: space-between;
  .menu-title {
    width: 192px;
    padding-left: 20px;
    color: #333333;
    line-height: 50px;
    font-size: 16px;
    background: #fff;
    border-bottom: 1px solid #edf0f7;
  }
}
.side-menu {
  width: 192px;
  margin-right: 20px;
  height: calc(100vh - 170px);
  background: #fff;
  overflow-y: auto;
  li {
    padding-left: 20px;
    color: #333333;
    border-left: 2px solid #fff;
    font-size: 14px;
    line-height: 50px;
    cursor: pointer;
    max-width: 192px;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: nowrap;
    &:hover {
      background: rgba(50, 115, 255, 0.15);
      color: #3273FF;
      border-left: 2px solid #3273FF;
    }
  }
  .current-group {
    background: rgba(50, 115, 255, 0.15);
    color: #3273FF;
    border-left: 2px solid #3273FF;
  }
}
.list-content {
  width: 1008px;
  height: calc(100vh - 120px);
  padding-bottom: 10px;
  background: #fff;
  .row-operation {
    display: flex;
    align-items: center;
    position: relative;
    line-height: 48px;
    // background: #edeff7;
    border-bottom: 1px solid #edf0f7;
    padding-left: 30px;
    &::before {
      position: absolute;
      left: 0;
      top: 17px;
      content: "";
      width: 4px;
      height: 15px;
      background: rgba(234, 85, 33, 1);
      border-radius: 2px;
    }
    .operate-btn {
      margin-bottom: 0;
      button {
        width: 80px;
        height: 30px;
      }
    }
  }

  .list {
    padding: 0 15px;
  }
  .el-pagination {
    margin: 15px 0 5px;
    text-align: center;
    .el-pager {
      li {
        background-color: #ffffff;
      }
    }
    .btn-prev,
    .btn-next {
      background-color: #ffffff;
    }
    .total {
      font-size: 12px;
      font-weight: normal;
      margin-right: 10px;
      em {
        padding: 0 2px;
        color: #4497ec;
        font-style: normal;
      }
    }
  }
}
</style>
